// extracted by mini-css-extract-plugin
export default {"root":"viewport-observer_root__pLHfu","placeHolderShimmer":"viewport-observer_placeHolderShimmer__8j+a7"};